var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDemoInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00002 1.83268C5.31812 1.83268 2.33335 4.81745 2.33335 8.49935C2.33335 12.1812 5.31812 15.166 9.00002 15.166C12.6819 15.166 15.6667 12.1812 15.6667 8.49935C15.6667 4.81745 12.6819 1.83268 9.00002 1.83268ZM0.666687 8.49935C0.666687 3.89698 4.39765 0.166016 9.00002 0.166016C13.6024 0.166016 17.3334 3.89698 17.3334 8.49935C17.3334 13.1017 13.6024 16.8327 9.00002 16.8327C4.39765 16.8327 0.666687 13.1017 0.666687 8.49935Z",
    fill: "#0050AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.01019 3.80931C9.47043 3.80931 9.84353 4.1824 9.84353 4.64264L9.84353 9.67505C9.84353 10.1353 9.47043 10.5084 9.01019 10.5084C8.54996 10.5084 8.17686 10.1353 8.17686 9.67505L8.17686 4.64264C8.17686 4.1824 8.54995 3.80931 9.01019 3.80931Z",
    fill: "#0050AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.84068 12.4611C9.84068 12.9214 9.46758 13.2945 9.00734 13.2945H8.99734C8.53711 13.2945 8.16401 12.9214 8.16401 12.4611C8.16401 12.0009 8.53711 11.6278 8.99734 11.6278H9.00734C9.46758 11.6278 9.84068 12.0009 9.84068 12.4611Z",
    fill: "#0050AB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00735 3.77431C9.46758 3.77431 9.84068 4.14741 9.84068 4.60765L9.84068 9.64006C9.84068 10.1003 9.46758 10.4734 9.00735 10.4734C8.54711 10.4734 8.17401 10.1003 8.17401 9.64006L8.17401 4.60765C8.17401 4.14741 8.54711 3.77431 9.00735 3.77431Z",
    fill: "#0050AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemoInfo);
export default __webpack_public_path__ + "static/media/demoInfo.5b8ecc15e79ba4b0f6daba625228d28b.svg";
export { ForwardRef as ReactComponent };